export default __webpack_public_path__ + "static/media/fastener-placement-rectangle-rounded-back.e6d05da8.webp";